import { ErrorComponent } from '@ace-clublabs/payments-component-library';
import guyOnTheFloorImage from '../assets/GuyOnTheFloor.png';
import laptopGuyImage from '../assets/LaptopGuy.png';
import { useEffect } from 'react';
import { Cookies } from 'react-cookie';
import { TOKEN_KEY_PAYMENTS } from '../shared/constants';
import jwt_decode from 'jwt-decode';
import { getClubPhoneNumber } from '../utils/methods';
import { Header } from './Header';
import { ErrorType, PolicyType } from '../shared/types';
import { UtagHelper, UtagParam } from '../utils/utagHelper';
import { useGlobalState } from '../shared/state';
import { ProductType } from '@ace-clublabs/payment-types';
import { getMyAccountURL } from '@ace-clublabs/payments-helper';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { AppHeaderBackButton, Button, ButtonGroup, Typography } from '@ace-clublabs/shared-component-library';

export interface ErrorProps {
  type: ErrorType;
}

export const ErrorPage: React.FC<ErrorProps> = ({ type }) => {
  const [clubCode, setClubCode] = useGlobalState('clubCode');
  const clubPhoneNumber = getClubPhoneNumber(clubCode);
  const [sessionId] = useGlobalState('sessionId');
  const [selectedProduct] = useGlobalState('selectedProduct');
  const [referrer] = useGlobalState('referrer');
  const [billPlan] = useGlobalState('billPlan');
  const navigate = useNavigate();

  const productType = selectedProduct
    ? selectedProduct.policyType === PolicyType.Membership
      ? ProductType.Membership
      : ProductType.Insurance
    : undefined;

  let error = '';
  let page = '';
  let title: string;
  let image = guyOnTheFloorImage;
  switch (type) {
    case ErrorType.PROCESSING_ERROR:
      title = 'Sorry, there was a problem processing your request';
      error = 'updating auto pay card fail';
      page = UtagHelper.Pages.errorCard;
      break;
    case ErrorType.GW_AUTOPAY_INELIGIBLE_ERROR:
      title = 'This policy is temporarily unavailable for Auto Pay enrollment';
      image = laptopGuyImage;
      error = 'system error';
      page = UtagHelper.Pages.errorSystem;
      break;
    case ErrorType.MEMBERSHIP_PIT_ERROR:
      title = 'Auto Pay is unavailable because there is already a payment pending';
      image = laptopGuyImage;
      error = 'pit error';
      page = UtagHelper.Pages.errorSystem;
      break;
    case ErrorType.SYSTEM_ERROR:
    default:
      title = 'Our systems are temporarily unavailable';
      error = 'system error';
      page = UtagHelper.Pages.errorSystem;
      break;
  }

  const onClickFindBranch = () => (window.location.href = 'https://www.ace.aaa.com/locations.html');

  const onClickBackToMyAccount = () => {
    window.location.href = getMyAccountURL();
  };

  const onClickBackToReferrer = () => {
    referrer ? (window.location.href = referrer) : onClickBackToMyAccount();
  };

  useEffect(() => {
    const cookies = new Cookies();
    const authToken = cookies.get(TOKEN_KEY_PAYMENTS);
    let tagClubCode = '';
    if (authToken) {
      const decoded: any = jwt_decode(authToken);
      tagClubCode = decoded['clubCode'] || clubCode || '004';
      setClubCode(tagClubCode);
    }

    const tags = {
      ...UtagHelper.CommonTaggingValues,
      page,
      sessionid: sessionId,
      clubcode: tagClubCode,
      error,
      mem_billplan: billPlan,
      ...(selectedProduct && { flow: productType === ProductType.Membership ? 'membership' : 'insurance' }),
    } as UtagParam;
    UtagHelper.tag(tags);
  }, []);

  const gwError = type === ErrorType.GW_AUTOPAY_INELIGIBLE_ERROR;

  return (
    <div className="container">
      <Header />
      <AppHeaderBackButton
        id="back-button"
        label={gwError || error === 'system error' ? 'Back' : 'Back to Manage Auto Pay'}
        onClick={
          error === 'system error'
            ? onClickBackToReferrer
            : gwError
            ? onClickBackToMyAccount
            : () => navigate(Pages.ManageAutoPay)
        }
      />
      {gwError ? (
        <div className="not-found-page">
          <img src={laptopGuyImage} alt="page-not-found-image" id="system-updating-image" />
          <Typography variant="h5Medium" className="not-found-text">
            {title}
          </Typography>
          <div className="assistance-text">
            We apologize for the inconvenience. If you need immediate assistance, specialists at your AAA branch would
            be happy to help.
          </div>
          <ButtonGroup>
            <Button
              variant="contained"
              label="Enroll and continue"
              id="find-branch-button"
              onClick={onClickFindBranch}
            ></Button>
            <Button
              variant="outlined"
              label="Back to My Account"
              id="my-account-button"
              onClick={onClickBackToMyAccount}
            ></Button>
          </ButtonGroup>
        </div>
      ) : (
        <ErrorComponent imagePath={image} phoneNumber={clubPhoneNumber} title={title} />
      )}
    </div>
  );
};
